import * as React from "react";
import styled from "styled-components";

import { transition } from "@ui/helpers";
import { Button } from "@ui/Atoms";
import { TableRow, TableCell } from "@ui/Atoms/Table";

export enum MY_CLEANINGS_LOAD_BUTTON_VARIANT {
  BUTTON,
  TABLE,
  LIST_ITEM,
}

interface Props {
  onClick: (
    event: React.MouseEvent<
      HTMLButtonElement | HTMLTableRowElement | HTMLAnchorElement
    >,
  ) => any;
  fetching: boolean;
  children: React.ReactNode;
  variant: MY_CLEANINGS_LOAD_BUTTON_VARIANT;
}

const StyledTableRow = styled(TableRow)`
  transition: ${transition(["opacity", "border-bottom"])};
  color: ${props => props.theme.palette.grey400};
  border-bottom: 0;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.palette.grey600};
  }
`;

const StyledTableCell = styled(TableCell)`
  display: table-cell;
  text-align: center;

  &:last-of-type {
    display: table-cell;
  }
`;

const StyledListItem = styled.li`
  text-align: center;
  padding-top: ${props => props.theme.margins.base};

  a {
    color: ${props => props.theme.palette.blue500};

    &:hover {
      color: ${props => props.theme.palette.blue500};
    }
  }
`;

export const TableLoadMoreButton = React.memo((props: Props) => {
  if (props.variant === MY_CLEANINGS_LOAD_BUTTON_VARIANT.BUTTON) {
    return (
      <TableRow>
        <StyledTableCell colSpan={7}>
          <Button
            onClick={props.onClick}
            disabled={props.fetching}
            variant="blue"
          >
            {props.children}
          </Button>
        </StyledTableCell>
      </TableRow>
    );
  }

  if (props.variant === MY_CLEANINGS_LOAD_BUTTON_VARIANT.LIST_ITEM) {
    return (
      <StyledListItem>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            props.onClick(e);
          }}
        >
          {props.children}
        </a>
      </StyledListItem>
    );
  }

  return (
    <StyledTableRow onClick={props.onClick}>
      <StyledTableCell colSpan={7}>{props.children}</StyledTableCell>
    </StyledTableRow>
  );
});

TableLoadMoreButton.displayName = "TableLoadMoreButton";
